// extracted by mini-css-extract-plugin
module.exports = {"waFloat":"whatsapp-module--wa-float--wsz6-","waIcon":"whatsapp-module--wa-icon--27Esy"};